/** @format */

export const CustomerActionTypes = {
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  REMOVE_CUSTOMER: 'REMOVE_CUSTOMER',
  CLEAR_CUSTOMER_SELECTION: 'CLEAR_CUSTOMER_SELECTION',
  UPDATE_MESSAGE_DATA: 'UPDATE_MESSAGE_DATA',

  CUSTOMER_DATA_RESET: 'CUSTOMER_DATA_RESET',
};
